import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de1a0bcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "o-page-wrapper-gutter min-h-45 w-full text-white flex items-center justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createBlock(_TransitionGroup, {
    name: "list",
    class: "w-full anim-trans",
    tag: "div"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apiMessages, (msg) => {
        return (_openBlock(), _createElementBlock("article", {
          key: msg.id,
          class: _normalizeClass(["border-t border-white cursor-pointer", _ctx.backgroundClass(msg)]),
          onClick: ($event: any) => (_ctx.clearApiMessage(msg.id))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString(_ctx.getMessage(msg)), 1),
            _createVNode(_component_c_icon, {
              name: "icon-plus-medium",
              height: "18",
              class: "rotate-45"
            })
          ])
        ], 10, _hoisted_1))
      }), 128))
    ]),
    _: 1
  }))
}